import styles from "./ProductStatusBox.module.scss";
import { ProductType } from "../../types/types";
import { GalleryButton } from "./components/GalleryButton";
import { ProductStatus } from "./components/ProductStatus";
import { Buttons } from "./components/Buttons";

type ProductStatusBoxUIProps = {
  handleImageClick: () => void;
  handleDescriptionCTA: () => void;
  handleCheckInStoreStockClick: () => void;
  handleShowEmwbisClick: () => void;
  image: string;
  title: string;
  price: string;
  productType?: ProductType;
  showEmwbis: boolean;
  statusMessage: string;
};

export const ProductStatusBoxUI = ({
  image,
  title,
  price,
  handleImageClick,
  handleDescriptionCTA,
  handleShowEmwbisClick,
  handleCheckInStoreStockClick,
  productType,
  showEmwbis,
  statusMessage,
}: ProductStatusBoxUIProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <GalleryButton
          handleImageClick={handleImageClick}
          image={image}
          title={title}
        />
        <div className={styles.content}>
          <ProductStatus
            handleDescriptionCTA={handleDescriptionCTA}
            price={price}
            productType={productType}
            statusMessage={statusMessage}
            title={title}
          />
          <Buttons
            handleCheckInStoreStockClick={handleCheckInStoreStockClick}
            handleShowEmwbisClick={handleShowEmwbisClick}
            productType={productType}
            showEmwbis={showEmwbis}
          />
        </div>
      </div>
    </div>
  );
};
